import "./Landing.css";

export default function Landing() {
  return (
    <div id="landing">
      <h1 className="intro">
        <span className="greeting">Hi, my name is Jubran.</span> <br />
        <span className="greeting1">
          I'm a Software
          <br />
          Engineer.
        </span>
      </h1>
    </div>
  );
}
